/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_5_DescInputs */

const en_mk_cap_5_desc = /** @type {(inputs: Mk_Cap_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a PDF, image or spreadsheet to an issue; the agent may read it if you allow it.`)
};

const id_mk_cap_5_desc = /** @type {(inputs: Mk_Cap_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah PDF, gambar, atau spreadsheet ke issue; agen boleh membacanya kalau Anda mengizinkan.`)
};

/**
* | output |
* | --- |
* | "Upload a PDF, image or spreadsheet to an issue; the agent may read it if you allow it." |
*
* @param {Mk_Cap_5_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_5_desc = /** @type {((inputs?: Mk_Cap_5_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_5_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_5_desc(inputs)
	return en_mk_cap_5_desc(inputs)
});